import { DlpTemplateModalNameEnum, DlpTemplateModalState } from '../type';
import { DeleteModal } from './delete';
import { EditOrAddModal } from './editOrAdd';
import { ImportModal } from './import';

export const TemplateModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpTemplateModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  if (modalState.name === DlpTemplateModalNameEnum.Delete) {
    return (
      <DeleteModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (
    modalState.name === DlpTemplateModalNameEnum.Add ||
    modalState.name === DlpTemplateModalNameEnum.Edit
  ) {
    return (
      <EditOrAddModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (modalState.name === DlpTemplateModalNameEnum.Import) {
    return (
      <ImportModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }
  return <></>;
};
